import { Api } from "@/models/class/api.class";
import { Pagination } from "@/models/constant/interface/common.interface";
import { WorkOrderCsfDto } from "@/models/interface/csf";
import {
  ErrorResponseModel,
  RequestQueryParamsModel,
} from "@/models/interface/http.interface";
import { AxiosError } from "axios";
import { HttpClient } from "./HttpClient.service";

class CsfService extends HttpClient {
  getList(
    params?: RequestQueryParamsModel
  ): Promise<Pagination<WorkOrderCsfDto>> {
    return this.get<Pagination<WorkOrderCsfDto>>(Api.CsfList, {
      params,
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }
}

export const csfService = new CsfService();
